import React, { Component } from 'react';

export default class TestToolsLauncher extends Component {
  constructor(props) {
    super(props);

    const savedPos = this.loadFromLS('testTools.pos');

    this.state = {
      pos: savedPos || { x: window.innerWidth - 160, y: window.innerHeight - 80 },
      dragging: false,
      dragOffset: { x: 0, y: 0 },
      startX: 0,
      startY: 0,
    };

    this.launcherRef = React.createRef();
  }

  componentDidMount() {
    this.clampPositionToViewport();
    window.addEventListener('resize', this.clampPositionToViewport);
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.onDragMove);
    window.removeEventListener('mouseup', this.onDragEnd);
    window.removeEventListener('resize', this.clampPositionToViewport);
  }

  loadFromLS = (key) => {
    try {
      const value = localStorage.getItem(key);
      if (value) return JSON.parse(value);
    } catch (e) {
      // ignore parse errors
    }
    return null;
  };

  saveToLS = (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      // ignore storage errors
    }
  };

  clampPositionToViewport = () => {
    const launcherW = this.launcherRef.current ? this.launcherRef.current.offsetWidth : 140;
    const launcherH = this.launcherRef.current ? this.launcherRef.current.offsetHeight : 34;

    const { pos } = this.state;
    const clampedX = Math.max(0, Math.min(pos.x, window.innerWidth - launcherW));
    const clampedY = Math.max(0, Math.min(pos.y, window.innerHeight - launcherH));

    if (clampedX !== pos.x || clampedY !== pos.y) {
      this.setState({ pos: { x: clampedX, y: clampedY } });
    }
  };

  onMouseDown = (e) => {
    // Record start position for click-vs-drag discrimination
    this.setState({
      startX: e.clientX,
      startY: e.clientY,
      dragging: true,
      dragOffset: {
        x: e.clientX - this.state.pos.x,
        y: e.clientY - this.state.pos.y,
      },
    });

    window.addEventListener('mousemove', this.onDragMove);
    window.addEventListener('mouseup', this.onDragEnd);
  };

  onDragMove = (e) => {
    if (!this.state.dragging) return;

    const { dragOffset } = this.state;
    const launcherW = this.launcherRef.current ? this.launcherRef.current.offsetWidth : 140;
    const launcherH = this.launcherRef.current ? this.launcherRef.current.offsetHeight : 34;

    let newX = e.clientX - dragOffset.x;
    let newY = e.clientY - dragOffset.y;

    newX = Math.max(0, Math.min(newX, window.innerWidth - launcherW));
    newY = Math.max(0, Math.min(newY, window.innerHeight - launcherH));

    this.setState({ pos: { x: newX, y: newY } });
  };

  onDragEnd = (e) => {
    const { startX, startY } = this.state;
    const moved = Math.abs(e.clientX - startX) + Math.abs(e.clientY - startY);

    if (moved < 4) {
      // Treat as click (but never when the close button was the target)
      if (!e.target.classList.contains('tt-launcher-close')) {
        this.props.onOpen();
      }
    } else {
      // Was a drag, persist position
      this.saveToLS('testTools.pos', this.state.pos);
    }

    this.setState({ dragging: false });
    window.removeEventListener('mousemove', this.onDragMove);
    window.removeEventListener('mouseup', this.onDragEnd);
  };

  handleHide = (e) => {
    e.stopPropagation();
    this.props.onHide();
  };

  render() {
    const { pos } = this.state;

    return (
      <div
        className="tt-launcher"
        ref={this.launcherRef}
        style={{
          position: 'fixed',
          left: pos.x,
          top: pos.y,
          zIndex: 9999,
        }}
        onMouseDown={this.onMouseDown}
      >
        <span style={{ marginRight: '6px' }}>🔧</span>
        <span>Test Tools</span>
        <button
          className="tt-launcher-close"
          onMouseDown={(e) => e.stopPropagation()}
          onClick={this.handleHide}
          type="button"
          aria-label="Hide test tools"
        >
          ×
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/test-tools/TestToolsLauncher.js